import { createApolloFetch } from 'apollo-fetch';
import { api2Url } from '../Store/api.slice';

const { REACT_APP_API_URL, REACT_APP_API_URL_LOCAL, REACT_APP_REPORTS_API_URL, REACT_APP_REPORTS_API_URL_LOCAL } = process.env;
const apiUrl = REACT_APP_API_URL && REACT_APP_API_URL.startsWith('http') ? REACT_APP_API_URL : REACT_APP_API_URL_LOCAL || '';
const reportApiUrl = REACT_APP_REPORTS_API_URL && REACT_APP_REPORTS_API_URL.startsWith('http') ? REACT_APP_REPORTS_API_URL : REACT_APP_REPORTS_API_URL_LOCAL || '';
let authorizationString = null;
if (window.parkchirp && window.parkchirp.auth) {
  const { token } = window.parkchirp.auth;
  authorizationString = `Bearer ${token}`;
}

export function fetchGeneral(urlDirectory, options) {
  const url = `${apiUrl}${urlDirectory}`;
  return fetchFromUrl(url, options);
}
export function fetchReport(options) {
  const url = `${reportApiUrl}/generateReport`;
  return fetchFromUrl(url, options);
}
function fetchFromUrl(url, options){
  options = options || {};
  options.mode = options.mode || 'cors';
  if (authorizationString) {
    options.headers = options.headers || {};
    options.headers['Authorization'] = authorizationString;
    options.headers['Content-Type'] = 'application/json';
  }
  return fetch(url, options);
}

export const fetchGraphQL = createApolloFetch({ uri: `${apiUrl}/graphql` });
export const fetchGraphQLv2 = createApolloFetch({ uri: `${api2Url}/graphql`});
export const fetchGraphQLPublic = createApolloFetch({ uri: `${apiUrl}/graphql_public` });

fetchGraphQL.use(({ options }, next) => {
  options.headers = options.headers || {};
  if (window.parkchirp && window.parkchirp.auth) {
    const { token } = window.parkchirp.auth;
    const authString = `Bearer ${token}`;
    options.headers['Authorization'] = authString;
  }
  next();
});

fetchGraphQLv2.use(({ options }, next) => {
  options.headers = options.headers || {};
  if (window.parkchirp && window.parkchirp.auth) {
    const { token } = window.parkchirp.auth;
    const authString = `Bearer ${token}`;
    options.headers['Authorization'] = authString;
  }
  next();
});
